import React, { useEffect, useState } from "react";
import {
  Tooltip
} from "@mui/material";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import "./ActiveDevices.css";
import configData from "../../config.json";
import ReconnectingEventSource from "reconnecting-eventsource";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams } from "react-router-dom";
import { getToken } from "../../utils/auth"

function ActiveDevices({
  event,
  trigger
}) {
  const [statusList, setStatusList] = useState(null);
  const [activeList, setActiveList] = useState([]);
  const [idleList, setIdleList] = useState([]);
  const [offlineList, setOfflineList] = useState([]);
  const [activeCount, setActiveCount] = useState(0);
  const [idleCount, setIdleCount] = useState(0);
  const [offlineCount, setOfflineCount] = useState(0);
  // const [refresh, setRefresh] = useState(false);
  const [openStream, setOpenStream] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
  const notify = (message, style) => {
    if (style === "success") {
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };
  useEffect(() => {
    const token = getToken()
    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };

    fetch(`${configData.SERVER_URL}/Devices/ActiveStatus/${params.retailer}/${params.store}`, { headers })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setStatusList(data);
        setOpenStream(true);
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  }, [trigger]);

  // useEffect(() => {
  //   const token = getToken()
  //   const headers = {
  //     "Content-Type": "application/json",
  //     "x-access-token": token,
  //   };
  //   if (statusList !== null) {
  //     const sse_status = new ReconnectingEventSource(
  //       `${configData.SERVER_URL
  //       }/Devices/ActiveStatus/Stream?token=${encodeURIComponent(token)}`,
  //       { headers }
  //     );

  //     const handleStream = (data) => {
  //       const message = JSON.parse(data.data);

  //       // Update the statusList state based on the previous state
  //       setStatusList((prevState) =>
  //         prevState.map((device) =>
  //           device.serial_number === message.serial_number
  //             ? {
  //               ...device,
  //               status: message.message === "START_JOURNEY",
  //             }
  //             : device
  //         )
  //       );

  //       // Toggle refresh to trigger a re-render
  //       setRefresh(!refresh);
  //       console.log(refresh, "refreshed");
  //     };

  //     sse_status.onopen = (e) => {
  //       console.log("connection opened");
  //     };

  //     sse_status.onmessage = (e) => {
  //       handleStream(e);
  //       console.log("got message: ", e);
  //     };

  //     sse_status.onerror = (e) => {
  //       console.log("got error:", e);
  //       sse_status.close();
  //       setTimeout(() => {
  //         console.log("reconnecting...");
  //         sse_status._start();
  //       }, 5000);
  //     };
  //     sse_status.onclose = (e) => {
  //       console.log("connection closed, attempting to reconnect...");
  //       sse_status.open();
  //     };
  //     window.addEventListener("beforeunload", () => {
  //       sse_status.close();
  //       console.log("closing sse_status before page is unloaded");
  //     });

  //     return () => {
  //       sse_status.close();
  //       console.log("return sse close");
  //     };
  //   }
  // }, [openStream]);
  useEffect(() => {
    if (!statusList) return; // If statusList is null or empty, return
    const activeDeviceslist = []
    const activeDevicesCount = statusList.reduce((count, item) => {
      if (item.retailer === params.retailer && item.store === params.store) {
        if (item.status === "active") {
          activeDeviceslist.push(item.serial_number);
          return count + 1;
        }
      }
      return count;
    }, 0);

    const idleDevicesList = [];
    const idleDevicesCount = statusList.reduce((count, item) => {
      if (item.retailer === params.retailer && item.store === params.store) {
        if (item.status === "idle") {
          idleDevicesList.push(item.serial_number);
          return count + 1;
        }
      }
      return count;
    }, 0);

    const offlineDevicesList = [];
    const offlineDevicesCount = statusList.reduce((count, item) => {
      if (item.retailer === params.retailer && item.store === params.store) {
        if (item.status === "offline") {
          offlineDevicesList.push(item.serial_number);
          return count + 1;
        }
      }
      return count;
    }, 0);

    setActiveList(activeDeviceslist)
    setActiveCount(activeDevicesCount);
    setIdleList(idleDevicesList)
    setIdleCount(idleDevicesCount);
    setOfflineList(offlineDevicesList)
    setOfflineCount(offlineDevicesCount);
  }, [statusList]);

  return (
    <div className="active-devices-container">
      {/* Active Devices Card */}
      <Tooltip
        title={
          <div
            style={{
              whiteSpace: "pre-line",
              maxHeight: "200px",        // adjust height as needed
              overflowY: "auto",
              paddingRight: "10px"       // optional for scroll clarity
            }}
          >
            {activeList.join("\n") || "No active devices"}
          </div>
        }
        arrow
      >
        <div className="active-devices-card">
          <h5 className="card-h5">Active</h5>
          <div className="devices-row">
            <span className="card-mute-text">{activeCount}</span>
            <span className="mui-active-icon card-icon">
              <ShoppingCartCheckoutIcon fontSize="large" />
            </span>
          </div>
        </div>
      </Tooltip>


      {/* Idle Devices Card */}
      
      <Tooltip
        title={
          <div
            style={{
              whiteSpace: "pre-line",
              maxHeight: "200px",        // limit height
              overflowY: "auto",         // enable vertical scroll
              paddingRight: "10px"       // optional spacing for scrollbar
            }}
          >
            {idleList.join("\n") || "No idle devices"}
          </div>
        }
        arrow
      >
        <div className="idle-devices-card">
          <h5 className="card-h5">Idle</h5>
          <div className="devices-row">
            <span className="card-mute-text">{idleCount}</span>
            <span className="mui-idle-icon card-icon">
              <ShoppingCartIcon fontSize="large" />
            </span>
          </div>
        </div>
      </Tooltip>

      

      {/* Offline Devices Card */}
      <Tooltip
        title={
          <div
            style={{
              whiteSpace: "pre-line",
              maxHeight: "200px",        // limit height
              overflowY: "auto",         // vertical scroll if content is long
              paddingRight: "10px"       // prevent scrollbar from overlapping text
            }}
          >
            {offlineList.join("\n") || "No offline devices"}
          </div>
        }
        arrow
      >
        <div className="offline-devices-card">
          <h5 className="card-h5">Offline</h5>
          <div className="devices-row">
            <span className="card-mute-text">{offlineCount}</span>
            <span className="mui-offline-icon card-icon">
              <ShoppingCartIcon fontSize="large" />
            </span>
          </div>
        </div>
      </Tooltip>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div >
  );
}

export default ActiveDevices;
